<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 236.236 203.725"
  >
    <g
      id="Retângulo_10"
      data-name="Retângulo 10"
      transform="translate(0 27.725)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <rect
      id="Retângulo_12"
      data-name="Retângulo 12"
      width="93"
      height="49"
      transform="translate(144.588 116.001) rotate(-90)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-check"
      data-name="Icon awesome-check"
      d="M68.688,169.053,2.962,95.934a12.163,12.163,0,0,1,0-15.909l14.3-15.909a9.4,9.4,0,0,1,14.3,0l44.277,49.256,94.836-105.5a9.406,9.406,0,0,1,14.3,0l14.3,15.909a12.163,12.163,0,0,1,0,15.909L82.988,169.054A9.406,9.406,0,0,1,68.688,169.053Z"
      transform="translate(34 -4.577)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
